export var Configuration;
(function (Configuration) {
    let ComponentNames;
    (function (ComponentNames) {
        ComponentNames["country"] = "country";
        ComponentNames["share"] = "share";
        ComponentNames["simpleButton"] = "simple_button";
        ComponentNames["modalScreen"] = "modal_screen";
        ComponentNames["section"] = "section";
        ComponentNames["icon"] = "icon";
        ComponentNames["phoneInput"] = "phone_input";
        ComponentNames["countryList"] = "country_list";
        ComponentNames["baseScreen"] = "base_screen";
        ComponentNames["header"] = "header";
        ComponentNames["headerButton"] = "header_button";
        ComponentNames["rootScreen"] = "root_screen";
        ComponentNames["profilesList"] = "profiles_list";
        ComponentNames["customScreen"] = "custom_screen";
        ComponentNames["sidebar"] = "sidebar";
        ComponentNames["baseButton"] = "base_button";
        ComponentNames["toggleButton"] = "toggle_button";
        ComponentNames["fabButton"] = "fab_button";
        ComponentNames["denseButton"] = "dense_button";
        ComponentNames["circleProgress"] = "circle_progress";
        ComponentNames["primaryButton"] = "primary_button";
        ComponentNames["secondaryButton"] = "secondary_button";
        ComponentNames["tertiaryButton"] = "tertiary_button";
        ComponentNames["underlineButton"] = "underline_button";
        ComponentNames["cardFooter"] = "card_footer";
        ComponentNames["cardHeader"] = "card_header";
        ComponentNames["card"] = "card";
        ComponentNames["collapseCard"] = "collapse_card";
        ComponentNames["switch"] = "check";
        ComponentNames["checkbox"] = "checkbox";
        ComponentNames["stepper"] = "stepper";
        ComponentNames["choiceItemInput"] = "choice_item_input";
        ComponentNames["choiceItemSelect"] = "choice_item_select";
        ComponentNames["choiceItem"] = "choice_item";
        ComponentNames["choiceItemText"] = "choice_item_text";
        ComponentNames["choice"] = "choice";
        ComponentNames["chatItem"] = "chat_item";
        ComponentNames["loading"] = "loading";
        ComponentNames["container"] = "container";
        ComponentNames["shell"] = "shell";
        ComponentNames["notification"] = "notification";
        ComponentNames["skeleton"] = "skeleton";
        ComponentNames["toast"] = "toast";
        ComponentNames["input"] = "input";
        ComponentNames["search"] = "search";
        ComponentNames["searchItem"] = "search_item";
        ComponentNames["floatingInput"] = "floating_input";
        ComponentNames["inlineModal"] = "inline_modal";
        ComponentNames["modal"] = "modal";
        ComponentNames["tabsPanel"] = "tabs_panel";
        ComponentNames["navigationWrapper"] = "navigation_wrapper";
        ComponentNames["navigator"] = "navigator";
        ComponentNames["tab"] = "tab";
        ComponentNames["inlineStepProgressBar"] = "inline_step_progress_bar";
        ComponentNames["progressBar"] = "progress_bar";
        ComponentNames["progressBarStep"] = "progress_bar_step";
        ComponentNames["stepProgressBar"] = "step_progress_bar";
        ComponentNames["bold"] = "bold";
        ComponentNames["h1"] = "h1";
        ComponentNames["h2"] = "h2";
        ComponentNames["h3"] = "h3";
        ComponentNames["h4"] = "h4";
        ComponentNames["h5"] = "h5";
        ComponentNames["h6"] = "h6";
        ComponentNames["paragraph"] = "paragraph";
        ComponentNames["small"] = "small";
        ComponentNames["textRow"] = "text_row";
        ComponentNames["text"] = "text";
        ComponentNames["errorPopUp"] = "error_pop_up";
        ComponentNames["popUp"] = "pop_up";
        ComponentNames["import"] = "import";
        ComponentNames["loadingPopUp"] = "loading_pop_up";
        ComponentNames["slider"] = "slider";
        ComponentNames["toggleBaseButton"] = "toggle_base_button";
        ComponentNames["animatedText"] = "animated_text";
        ComponentNames["chips"] = "chips";
        ComponentNames["infoButton"] = "info_button";
        ComponentNames["datePicker"] = "date_picker";
        ComponentNames["select"] = "select";
        ComponentNames["datePickerButton"] = "date_picker_button";
        ComponentNames["datePickerCalendar"] = "date_picker_calendar";
        ComponentNames["datePickerSelector"] = "date_picker_selector";
        ComponentNames["animatedScroll"] = "animated_scroll";
        ComponentNames["notificationsPermission"] = "notifications_permission";
        ComponentNames["appUpdate"] = "app_update";
        ComponentNames["pushNotification"] = "push_notification";
        ComponentNames["shareScreen"] = "share_screen";
        ComponentNames["cachedImage"] = "cached_image";
    })(ComponentNames = Configuration.ComponentNames || (Configuration.ComponentNames = {}));
})(Configuration || (Configuration = {}));
